import moment from 'moment';

const TableSingle = ({ columns, dataSource }) => {
  const onFormat = (data, format) => {
    if (!data && data !== 0) return '';
    return parseFloat(data).toFixed(format?.precision);
  };
  const numberToCurrency = x => {
    if (!x && x !== 0) return '';
    return x.toString().replace(/\B(?!\.\d)(?=(\d{3})+(?!\d))/g, ',');
  };
  return (
    <table className="table-custom-popupproduct">
      <tbody>
        <tr>
          {columns?.map((o, i) => (
            <th
              key={i}
              colSpan={o?.columns?.length || 1}
              style={{
                color: o?.color || 'inhert',
                whiteSpace: 'pre-wrap',
                position: 'sticky',
                top: 0,
                backgroundColor: '#E4E7EC',
              }}
            >
              {o?.caption || o?.label}
            </th>
          ))}
        </tr>
        {dataSource?.map((o, i) => (
          <tr key={i}>
            {columns?.map((f, j) => (
              <td key={j}>
                {f?.format
                  ? numberToCurrency(onFormat(o?.[f.dataField], f?.format))
                  : f.type === 'date'
                  ? moment(o?.[f.dataField]).format('YYYY-MM-DD')
                  : o?.[f.dataField]}
              </td>
            ))}
          </tr>
        ))}
      </tbody>
    </table>
  );
};

export default TableSingle;
